/*
*  Dialog view for allowing a user to edit a Deployment
*
*  The dialog allows the user to...
*     Edit the 'flagged'/'promoted' value of the deployment
*     Edit the deployment description
*/

import Radio from 'backbone.radio';
import Marionette from 'backbone.marionette';
import _ from 'underscore';
import Handlebars from 'handlebars';
import DialogInterface from '@/interfaces/dialog';
import strings_common from 'amdi18n-loader!@/nls/common';
import strings_specific from 'amdi18n-loader!@/nls/dialogs';
import template from '@/../templates/edit-deployment-dialog.hbs';
import Api from '@/lib/api/api';
var strings = _.extend({}, strings_common, strings_specific);

var MAX_NAME_LENGTH = 300;

const globalCh = Radio.channel('global');

const deployment_permission_by_group = {
  development_devicegroup: 'update_development_deployment',
  pre_production_devicegroup: 'update_pre_production_deployment',
  pre_dut_devicegroup: 'update_pre_factory_deployment',
  pre_factoryfixture_devicegroup: 'update_pre_factory_deployment',
  production_devicegroup: 'update_production_deployment',
  dut_devicegroup: 'update_factory_deployment',
  factoryfixture_devicegroup: 'update_factory_deployment'
};

function can(perm) {
    let primary = globalCh.request('primary_account');
    let active = globalCh.request('active_account');
    return active.permits(primary, perm);
}

var View = Marionette.View.extend(DialogInterface).extend({
    template: Handlebars.compile(template),
    ui: {
        flagged: '.flagged',
        description: '.description',
        submit_btn: '.submit',
        load_spinner: '.loader',
        tooltips: '[data-toggle="tooltip"]',
        description_length_counter: '.description-counter'
    },
    regions: {
        deployment_settings: '.deployment-settings',
    },
    events: {
        'submit form': 'save_deployment',
        'click @ui.flagged': 'handle_flagged',
        'keyup @ui.description': 'validate',
        'paste @ui.description': 'validate',
        'change @ui.description': 'validate',
        'mouseup @ui.description': 'validate',
    },
    initialize: function (options) {
        this.destroyOnClose();
        this.focusFirstInput();
    },
    templateContext: function(){
        let devicegroup_type = this.model.rel.get('devicegroup').type;
        let permission_string = deployment_permission_by_group[devicegroup_type];
        let can_update_deployment = can(permission_string);
        var data = {
            s : strings,
            is_create : !this.model,
            disable_edit: !can_update_deployment
        };

        return data;
    },
    validate: function () {
        if ( this.ui.description.val() ) {
            this.check_validation(
                this.ui.description,
                MAX_NAME_LENGTH,
                this.ui.description_length_counter
            );
        }
    },
    onRender: function () {
        this.validate();
        this.ui.tooltips.tooltip();
    },

    handle_flagged: function(e) {
        if ( this.model.get('flagged') ){
            this.model.set('flagged', false);
        } else {
            this.model.set('flagged', true);
        }
        
    },

    save_deployment: function(e) {
        e.preventDefault(e);
        this.model.save({
            data: {
                type: this.model.type,
                id: this.model.id,
                attributes: {
                    flagged: this.model.get('flagged'),
                    description: this.ui.description.val()
                }
            }
        },
        {
            patch: true,
            url: Api.urls.deployment_nocode({ id: this.model.id, nocode: true }),
            success: function(model, response){
                this.on_success(model, 'Successfully saved deployment');
            }.bind(this),
            error: function (model, response) {
                this.on_error(response.responseJSON.errors[0].detail);
            }.bind(this)
        });
    },

    on_success: function (deployment, message) {
        Radio.request('alerts', 'showAlert', {
            message: message,
            messageType: 'success'
        });
        this.closeDialog();
    },

    on_error: function (error) {
        this.showAlert('alert-danger', error);
    }
});
export default View;

